<div provide-parent-form *ngIf="playout" class="playout-positions">
	<div *ngIf="adSchedule">
		<div>
			<p>
				<strong>
					{{ 'CONNECTED_AD_SCHEDULE' | translate }}
				</strong>
			</p>
		</div>
		<div [title]="adSchedule?.code">
			<i class="fa fa-bars-staggered"></i> {{ adSchedule?.title }}
		</div>

		<a [routerLink]="['/adservices/adschedule/', adSchedule.id]" class="big button">
			<i class="fa fa-bullhorn"></i>
			{{ 'MANAGE_IN_AD_SERVICES' | translate }}
		</a>
	</div>

	<ng-container *ngIf="!adSchedule && !loadingAdSchedule">
		<p>
			<label>{{ 'PREROLL' | translate }}</label><br />
			<ng-container *ngIf="playout.adunitsPreroll?.length">
				<span
					*ngIf="playout.adunitsPreroll[0].assignedLineitems?.length === 1">'{{ playout.adunitsPreroll[0].title }}'
					{{ 'WITH_1_LINE_ITEM' | translate }}</span>
				<span
					*ngIf="playout.adunitsPreroll[0].assignedLineitems?.length !== 1">'{{ playout.adunitsPreroll[0].title }}'
					{{ 'WITH_X_LINE_ITEMS' | translate: {amount: playout.adunitsPreroll[0].assignedLineitems.length} | lowercase }}</span>
			</ng-container>
			<span *ngIf="!playout.adunitsPreroll?.length" class="none">{{ 'NONE' | translate }}</span>
		</p>

		<p>
			<label>{{ 'POSTROLL' | translate }}</label><br />
			<ng-container *ngIf="playout.adunitsPostroll?.length">
				<span
					*ngIf="playout.adunitsPostroll[0].assignedLineitems?.length === 1">'{{ playout.adunitsPostroll[0].title }}'
					{{ 'WITH_1_LINE_ITEM' | translate }}</span>
				<span
					*ngIf="playout.adunitsPostroll[0].assignedLineitems?.length !== 1">'{{ playout.adunitsPostroll[0].title }}'
					{{ 'WITH_X_LINE_ITEMS' | translate: {amount: playout.adunitsPostroll[0].assignedLineitems.length} | lowercase }}</span>
			</ng-container>
			<span *ngIf="!playout.adunitsPostroll?.length" class="none">{{ 'NONE' | translate }}</span>
		</p>

		<a [routerLink]="['/adservices/position/playout/', playout.id]" class="big button">
			<i class="fa fa-bullhorn"></i>
			{{ 'MANAGE_IN_AD_SERVICES' | translate }}
		</a>
	</ng-container>
</div>
